export function SET_PROJECT(state, project) {
  state.projectSelected = project;
}
